import * as zod from 'zod';

export const GetROSControlEnabledResponse = zod.object({
  enabled: zod.boolean(),
});

export type GetROSControlEnabledResponse = zod.infer<
  typeof GetROSControlEnabledResponse
>;
